/* Rotating announcement bar: auto-rotate, pause on hover, arrows, pause button */
if (!customElements.get('rotating-bar')) {
  class RotatingBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-annc-slide]'));
      if (this.slides.length === 0) return;

      this.index = 0;
      this.interval = (parseFloat(this.dataset.interval) || 5) * 1000;
      this.mode = this.dataset.transition === 'fade' ? 'fade' : 'slide';
      this.autoplay = this.dataset.autoplay !== 'false' && this.slides.length > 1;
      this.paused = false;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.classList.add(this.mode === 'fade' ? 'annc--fade' : 'annc--slide');

      const prev = this.querySelector('[data-annc-prev]');
      const next = this.querySelector('[data-annc-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1, true));
      if (next) next.addEventListener('click', () => this.step(1, true));

      this.pauseBtn = this.querySelector('[data-annc-pause]');
      if (this.pauseBtn) {
        this.pauseBtn.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.pauseBtn.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
          this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Resume message rotation' : 'Pause message rotation');
          if (this.userPaused) this.stop();
          else this.start();
        });
      }

      // Hovering or focusing the bar holds the current message so it can be read.
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => { if (!this.userPaused) this.start(); });
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => { if (!this.userPaused) this.start(); });

      this.onVisibility = () => {
        if (document.hidden) this.stop();
        else if (!this.userPaused) this.start();
      };
      document.addEventListener('visibilitychange', this.onVisibility);

      if (this.slides.length > 1 && this.autoplay) this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    start() {
      if (!this.autoplay || this.timer) return;
      this.timer = setInterval(() => this.step(1, false), this.interval);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    step(dir, fromClick) {
      const total = this.slides.length;
      if (total < 2) return;
      const current = this.slides[this.index];
      const nextIndex = (this.index + dir + total) % total;
      const incoming = this.slides[nextIndex];

      if (this.mode === 'fade' || this.reduce) {
        current.classList.remove('is-active');
        incoming.classList.add('is-active');
      } else {
        const leaving = dir > 0 ? 'is-leaving-left' : 'is-leaving-right';
        const entering = dir > 0 ? 'is-entering-right' : 'is-entering-left';
        incoming.classList.add(entering);
        // force a reflow so the start position is applied before transitioning in
        void incoming.offsetWidth;
        incoming.classList.remove(entering);
        incoming.classList.add('is-active');
        current.classList.remove('is-active');
        current.classList.add(leaving);
        setTimeout(() => current.classList.remove(leaving), 700);
      }

      this.index = nextIndex;
      if (fromClick && this.timer) {
        this.stop();
        if (!this.userPaused) this.start();
      }
    }
  }
  customElements.define('rotating-bar', RotatingBar);
}
